var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['button-list', _vm.classButtonList]},[_c('div',{staticClass:"button-list__buttons"},_vm._l((_vm.buttons),function(button,buttonIndex){return _c('a',_vm._b({key:buttonIndex,class:[
        'hot-button',
        'hot-button--transparent',
        'hot-button--lg',
        'button-list__button',
        `button-list__button--${button.variation}`,
        `button-list__button--${_vm.type}`,
      ],attrs:{"href":button.href,"target":button.target}},'a',button.gtm,false),[_c('span',{staticClass:"button-list__button-icon"},[_c('hot-icon',{attrs:{"name":button.icon.name}})],1),_vm._v(" "),_c('span',{staticClass:"button-list__button-label",domProps:{"innerHTML":_vm._s(button.label)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }